var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMarketingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "20px",
    viewBox: "0 0 23 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "41FAF0CB-942F-49F2-817D-F1D9A3A2DBA9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wiki",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12-wiki-Details",
    transform: "translate(-119.000000, -218.000000)",
    fill: "#FF5000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-topic",
    transform: "translate(100.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Marketing",
    transform: "translate(0.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-Marketing-Icon",
    transform: "translate(19.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Marketing-Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12378641,6.25 L0.8,6.25 L0.8,13.7815534 L3.91650485,13.7815534 L3.91650485,18.7679612 L5.47475728,18.7679612 L5.47475728,13.7815534 L8.14975728,13.7815534 L18.8237864,19.1315534 L18.8237864,13.8075243 L22.2,12.5089806 L22.2,7.26286408 L18.8237864,5.96432039 L18.8237864,0.9 L8.12378641,6.25 Z M2.35825243,7.80825243 L7.55242718,7.80825243 L7.55242718,12.223301 L2.35825243,12.223301 L2.35825243,7.80825243 Z M17.265534,16.6123786 L9.11067961,12.5349515 L9.11067961,7.49660194 L17.265534,3.41917476 L17.265534,16.6123786 Z M20.6417476,8.3276699 L20.6417476,11.4441748 L18.8237864,12.1453883 L18.8237864,7.62645631 L20.6417476,8.3276699 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketingIcon);
export default __webpack_public_path__ + "static/media/icon-Marketing-Icon.96ff9b929321033a8fa531a8a020f0ec.svg";
export { ForwardRef as ReactComponent };